export default "__VITE_ASSET__C0gMBWOy__"